import { ApiTokenDashboard } from '@/components/api-token/overview'
import { createFileRoute } from '@tanstack/react-router'
import { store } from '@/state/breadcrumb-store'

export const Route = createFileRoute('/api-token')({
  component: RouteComponent,
})

function RouteComponent() {
  store.trigger.changePath({
    newPath:
      [{ params: {}, to: "/api-token", label: "API Token" }]
  })
  return <ApiTokenDashboard></ApiTokenDashboard>
}
